import { createSlice } from "@reduxjs/toolkit"

let initialData:any = {
    tabs: [
        'ACADEMY_GOALS',
        //to develop in as next version
        // 'DEPARTMENT_GOALS',
        // 'MY_DEVELOPMENT',
        // 'STRATEGY_ANALYSIS',
        // 'CONFIG',
    ],
    currentTab: 'ACADEMY_GOALS',
    goals: null,
    selectedGoal: null,
    selectedSubGoal: null,
    goalsHeader: {
        vision: null,
        northStar: null,
    },
}

export const goalsAndStrategy = createSlice({
    name: 'goalsAndStrategy',
    initialState: initialData,
    reducers: {
        setCurrentTab: (state:any, action:any) => {
            state.currentTab = action.payload;
            return state;
        },
        setGoals: (state:any, action:any) => {
            state.goals = action.payload;
            return state;
        },
        setSelectedGoal: (state:any, action:any) => {
            state.selectedGoal = action.payload;
            return state;
        },
        resetSelectedGoal: (state:any) => {
            state.selectedGoal = initialData.selectedGoal;
            return state;
        },
        setSelectedSubGoal: (state:any, action:any) => {
            state.selectedSubGoal = action.payload;
            return state;
        },
        resetSelectedSubGoal: (state:any) => {
            state.selectedSubGoal = initialData.selectedSubGoal;
            return state;
        },
        setGoalsHeader: (state:any, action:any) => {
            state.goalsHeader = action.payload;
            return state;
        },
        resetGoalsHeader: (state:any) => {
            state.goalsHeader = initialData.goalsHeader;
            return state;
        },
        resetGoalsAndStrategy: (state:any) => {
            state = initialData;
            return state;
        },
    }
});

export const {
    setCurrentTab,
    setGoals,
    setSelectedGoal,
    resetSelectedGoal,
    setSelectedSubGoal,
    resetSelectedSubGoal,
    setGoalsHeader,
    resetGoalsHeader,
    resetGoalsAndStrategy,
} = goalsAndStrategy.actions;
export default goalsAndStrategy.reducer;